import service from '@/util/require';

export function getPublicKey() {
  return service({
    url: '/auth/publicKey',
    method: 'get'
  });
}

export function oauth2(data) {
    data.clientId = '1788467111848488960';
    data.grantTypeCode = 'password';
    return service({
        url: '/auth/oauth2',
        method: 'post',
        data
    });
}

export function getCaptcha(purpose) {
  return service({
    url: '/captcha/img/code',
    method: 'get',
    params: { purpose }
  });
}

export function verifyCaptcha(data) {
  return service({
    url: '/captcha/img/verify',
    method: 'post',
    data,
    skipAuthorization: true,
    silentError: true
  });
}

export function userRegister(data) {
  return service({
    url: '/auth/user-register',
    method: 'post',
    data
  });
}

export function institutionRegister(data) {
  return service({
    url: '/auth/institution-register',
    method: 'post',
    data
  });
}

export function enterpriseRegister(data) {
  return service({
    url: '/auth/enterprise-register',
    method: 'post',
    data
  });
}

export function getUserInfo() {
  return service({
    url: '/auth/userInfo',
    method: 'get'
  });
}

export function resetPassword(data) {
  return service({
    url: '/sys-user/password-reset',
    method: 'put',
    data
  });
}
